// @ts-strict-ignore
import WithContainerRoute from 'mobile_web/modules/common/hocs/container-route'
import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router'
import { getComponentParams } from '../../home/functions'
import ScreenWebComponent from '../components/ScreenWeb'

const ScreenWebRoute: FC<RouteComponentProps> = ({ location: { state }, match: { params } }) => {
	const { id: itemId, version: itemVersion, accountId } = getComponentParams('item', params, state)

	return <ScreenWebComponent itemId={itemId} itemVersion={itemVersion} accountId={accountId} />
}

export default WithContainerRoute(ScreenWebRoute)
